<template>
  <div id="app" class="app">
    <!-- <img src="./assets/logo.png"> -->
    <router-view v-if="isRouterAlive" />
  </div>
</template>

<script>
export default {
  name: 'App',
  provide(){
    return{
      reload:this.reload
    }
  },
  data(){
    return {
      isRouterAlive:true,   //默认当前页是显示状态
    }
  },
  mounted(){
    this.setSafariIpt();
    //应用场景字段对应名称及前缀可以在这里只请求一次，放在全局变量里
    // console.log('app mounted...')
    // this.axios.defaults.baseURL = 'http://192.168.0.211:9191'
    // console.log('app', this.axios.defaults)
  },
  beforeDestroy(){
    this.$ws.close();  //页面刷新关闭websocket
  },
  methods:{
    reload(){   //实现刷新当前页
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true
      });
    },
    setSafariIpt(){
      var version = navigator.userAgent.toLowerCase();
      if(version.match(/version\/([\d.]+).*safari/)?1:0){  //兼容safari
        //console.log("safari")
        // console.log(document.querySelector("body"))
        document.querySelector("body").classList.add("isSafari");
      }
    }
  }
}
</script>

<style>
#app {
  /* font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px; */
  width: 100%;
  height: 100%;
  /* box-sizing: border-box; */
  /* overflow-y: auto; */
}
/* reset.css */
html,
body {
    height: 100%;
    padding: 0;
    margin: 0;
    font: 14px  Arial,Helvetica,"Microsoft YaHei",sans-serif;
    background-color: #fff;
    overflow: hidden;
}
input{
    font-family: inherit;
}

input::-ms-clear{display:none;}
input::-ms-reveal{display:none;}

body a,
body a:focus,
body a:hover,
body a:active,
body a:visited {
    text-decoration: none;
    outline: 0;
}

/* Clears shit */

.clearfix:before,
.clearfix:after {
    content: " ";
    display: table;
}

.clearfix:after {
    clear: both;
}

.clearfix {
    zoom: 1;
}
.app .el-input__inner{
  border-color: #e7eaef;
  color: #58585b;
  height: 38px;
  line-height: 38px;
  font-size: 14px;
}
.app .el-form-item__content{
  line-height: 38px;
}
.app .el-form-item__label{
  height: 38px;
  line-height: 38px;
}
.app .el-form-item{
  margin-bottom: 30px;
}
.isSafari .el-input__inner{
  line-height:16px !important;
}
.isSafari .el-input.is-disabled .el-input__inner{
  color:#58585b !important;
}
input::-webkit-input-placeholder{
    /* color: #c0c4cc !important; */
    color: rgba(149,148,153,0.6) !important;
    font-size: 14px;
}
input:-ms-input-placeholder{
    /* color: #c0c4cc !important; */
    color: rgba(149,148,153,0.6) !important;
    font-size: 14px;
} 
input::-moz-placeholder{
    /* color: #797979 !important; */
    /*color: rgba(149,148,153,0.6) !important;*/
    color: rgba(66, 64, 61,0.6) !important;
    font-size: 14px;
}
input::-webkit-credentials-auto-fill-button {
    display: none !important;
    visibility: hidden;
    pointer-events: none;
    position: absolute; 
    right: 0;
}
.page-scroll{
  height: 100%;
}
.page-scroll .el-scrollbar__wrap {
  overflow-x: hidden;
}
.page-scroll .el-scrollbar__view{
  height: 100%;
}
/* .page-scroll .is-vertical{
  z-index: 3;
} */
.btn-popover{
  text-align: left;
}
.rePushCls {
  width: 250px !important;
}
.el-select-dropdown.el-popper .el-select-dropdown__wrap .el-scrollbar__view .selected{
  color:#4071fb !important;
}
.login-select .el-select-dropdown__item{
  color: #666;
}
/* table common css */
/* .custom-table.el-table--border{
    border: 1px solid #d9d9d9;
}
.custom-table .thCell, .custom-table .tdCell{
    font-size: 15px;
    border-color: #d9d9d9 !important;
}
.custom-table .thCell{
    background: rgb(249,249,249);
    color: #767676;
}
.custom-table .tdCell{
    color: #7a7a7a;
}
.custom-table .over .thCell, .custom-table .over .tdCell{
    background: rgb(241,247,255) !important;
} */

.globalMsg {
  top: 100px;
}
/* 标签页绑定功能查询标签模板提示 */
.noPermissionQuery{
  z-index: 3000 !important
}
/* 标签全部设备自适应 */
.allLabelTypeParent{
  max-width: 85%;
  max-height: 80%;
  overflow: auto;
  min-width: auto
}
</style>



// WEBPACK FOOTER //
// src/App.vue